import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Checkbox from '../../../general/Checkbox';
import Icon from '../../../general/Icon';
import Avatar from '../../../general/Avatar';
export default (_ref => {
  let {
    option,
    value,
    classes,
    override,
    getHighlighted
  } = _ref;
  const isSelected = value ? !!(value !== null && value !== void 0 && value.find(item => item.value === option.value)) : false;
  let bulletClasses = [classes.optionLabelBullet];
  let textClasses = [classes.optionLabelText];
  let iconClasses = [classes.optionLabelIcon];
  let customIconClasses = [classes.optionLabelCustomIcon];
  let subtitleClasses = [classes.optionLabelSubtitle];
  let isDisabled = option.isDisabled;
  if (override.optionLabel && override.optionLabel.getIsDisabled) isDisabled = override.optionLabel.getIsDisabled(option, isDisabled);
  if (isDisabled) {
    bulletClasses.push(classes.optionLabelBulletDisabled);
  } else if (option.type) {
    if (option.type === 'primary') bulletClasses.push(classes.optionLabelBulletPrimary);
    if (option.type === 'danger') bulletClasses.push(classes.optionLabelBulletDanger);
    if (option.type === 'success') bulletClasses.push(classes.optionLabelBulletSuccess);
  }
  if (isDisabled) {
    textClasses.push(classes.disabledText);
    subtitleClasses.push(classes.disabledText);
    if (option.iconType) iconClasses.push(classes.disabledIcon);
    if (option.customIcon) customIconClasses.push(classes.disabledIcon);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabel
  }, override.optionLabel), /*#__PURE__*/React.createElement(Checkbox, _extends({
    className: classes.optionLabelCheckbox,
    checked: isSelected,
    color: "orange",
    isDisabled: isDisabled || false
  }, override.optionLabelCheckbox)), option.type && /*#__PURE__*/React.createElement("div", _extends({
    className: bulletClasses.join(' ')
  }, override.optionLabelBullet)), option.iconType && /*#__PURE__*/React.createElement(Icon, _extends({
    className: iconClasses.join(' '),
    name: option.iconType,
    color: option.iconColor || null,
    size: "medium"
  }, override.optionLabelIcon)), option.icon && /*#__PURE__*/React.createElement("div", _extends({
    className: customIconClasses.join(' ')
  }, override.optionLabelCustomIcon), option.icon), option.src && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabelAvatar
  }, override.optionLabelAvatar), option.isDisabled && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.disabledAvatar
  }, override.disabledAvatar)), /*#__PURE__*/React.createElement(Avatar, {
    size: option.subLabel ? 'big' : 'small',
    src: option.src,
    placeholder: option.placeholder || '',
    alt: option.alt
  })), !option.subLabel && /*#__PURE__*/React.createElement("div", _extends({
    className: textClasses.join(' ')
  }, override.optionLabelText), getHighlighted && getHighlighted(option) || option.label), option.subLabel && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabelBlock
  }, override.optionLabelBlock), /*#__PURE__*/React.createElement("div", _extends({
    className: textClasses.join(' ')
  }, override.optionLabelText), getHighlighted && getHighlighted(option) || option.label), /*#__PURE__*/React.createElement("div", _extends({
    className: subtitleClasses.join(' ')
  }, override.optionLabelSubLabel), option.subLabel)));
});